(function() {
  let currentCartCount = 0;
  let isUpdating = false;
  let lastFetchTime = 0;
  let fetchTimeout = null;
  const FETCH_COOLDOWN = 500; // Minimum time between fetches (ms)

  // Function to update cart title with item count
  function updateCartTitle(itemCount, moveFocus = false) {
    const cartTitle = document.querySelector('mini-cart .mini-cart__header .title.h4');
    
    if (cartTitle) {
      const newText = itemCount === 0 ? 'Cart' :
                     itemCount === 1 ? '1 Item Added to Cart' :
                     `${itemCount} Items Added to Cart`;
      
      if (cartTitle.textContent !== newText) {
        cartTitle.textContent = newText;
        // document.querySelector('mini-cart').focus();
        // jQuery("mini-cart#mini-cart").focus();
        jQuery('.mini-cart__footer .button-container .button+.button').focus();
        // Move focus to cart title if requested
        // if (moveFocus) {
        //   // Make title focusable if it isn't already
        //   if (!cartTitle.hasAttribute('tabindex')) {
        //     cartTitle.setAttribute('tabindex', '-1');
        //   }
          
        //   // Add ARIA live region for screen readers
        //   cartTitle.setAttribute('aria-live', 'polite');
        //   cartTitle.setAttribute('role', 'status');

        //   // Focus on the title
        //   setTimeout(() => {
        //     cartTitle.focus();
        //   }, 100);
        // }
      }
    }
  }

  // Throttled function to get cart count - prevents too many requests
  function getCartCount() {
    const now = Date.now();
    
    // If we fetched recently, just use cached count
    if (now - lastFetchTime < FETCH_COOLDOWN) {
      updateCartTitle(currentCartCount);
      return;
    }

    // Clear any pending fetch
    if (fetchTimeout) {
      clearTimeout(fetchTimeout);
    }

    // Debounce the fetch
    fetchTimeout = setTimeout(() => {
      if (isUpdating) return;
      
      isUpdating = true;
      lastFetchTime = Date.now();
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          currentCartCount = cart.item_count;
          updateCartTitle(currentCartCount);
          isUpdating = false;
        })
        .catch(error => {
          console.error('Error fetching cart:', error);
          isUpdating = false;
          // Use cached count on error
          updateCartTitle(currentCartCount);
        });
    }, 100);
  }

  // Aggressive observer that constantly monitors the title
  function startTitleMonitor() {
    const cartTitle = document.querySelector('.mini-cart .title.h4');
    
    if (!cartTitle) {
      // If title doesn't exist yet, try again soon
      setTimeout(startTitleMonitor, 200);
      return;
    }

    // Watch for ANY changes to the title
    const titleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        const currentText = cartTitle.textContent.trim();
        
        // If title was reset to just "Cart" but we have items, fix it immediately
        if (currentText === 'Cart' && currentCartCount > 0) {
          updateCartTitle(currentCartCount);
        }
      });
    });

    titleObserver.observe(cartTitle, {
      childList: true,
      characterData: true,
      subtree: true
    });

    // Set initial title from cached count
    updateCartTitle(currentCartCount);
  }

  // Monitor when cart drawer opens/closes
  function observeCartDrawer() {
    const miniCart = document.querySelector('.mini-cart');
    
    if (!miniCart) {
      setTimeout(observeCartDrawer, 200);
      return;
    }

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const isOpen = miniCart.classList.contains('open') || 
                        miniCart.classList.contains('active') ||
                        miniCart.classList.contains('is-open');
          
          if (isOpen) {
            // Cart opened - fetch once and update title
            getCartCount();
          }
        }
      });
    });

    observer.observe(miniCart, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Intercept add to cart form submissions
  function interceptAddToCart() {
    // Original fetch backup
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const url = args[0];
      
      return originalFetch.apply(this, args).then(response => {
        // Only intercept cart/add requests
        if (typeof url === 'string' && url.includes('/cart/add')) {
          if (response.ok) {
            // Parse the response to get the item data
            response.clone().json().then(item => {
              // Increment cached count instead of fetching
              currentCartCount += item.quantity || 1;
              updateCartTitle(currentCartCount);
              
              // Fetch actual count after a delay to sync
              setTimeout(() => getCartCount(), 1000);
            }).catch(() => {
              // If parsing fails, fetch normally
              setTimeout(() => getCartCount(), 500);
            });
          }
        }
        
        return response;
      });
    };

    // Listen for form submissions
    document.addEventListener('submit', function(e) {
      const form = e.target;
      
      if (form.matches('form[action*="/cart/add"]')) {
        // Update after form submission
        setTimeout(() => getCartCount(), 500);
      }
    });

    // Listen for cart icon clicks
    document.addEventListener('click', function(e) {
      const target = e.target;
      
      // Check various cart trigger patterns
      if (target.matches('[href*="mini-cart"], [href*="#cart"]') || 
          target.closest('[href*="mini-cart"], [href*="#cart"]') ||
          target.matches('.cart-trigger, .cart-icon, [data-cart-trigger], .header-cart') ||
          target.closest('.cart-trigger, .cart-icon, [data-cart-trigger], .header-cart')) {
        
        // Update once when clicked
        getCartCount();
      }
    });
  }

  // Initial fetch to get cart count
  function initialFetch() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        currentCartCount = cart.item_count;
        updateCartTitle(currentCartCount);
        lastFetchTime = Date.now();
      })
      .catch(error => {
        console.error('Initial cart fetch error:', error);
      });
  }

  // Initialize everything
  function init() {
    initialFetch(); // Get initial count ONCE
    startTitleMonitor(); // Start monitoring title changes
    observeCartDrawer(); // Watch for cart open/close
    interceptAddToCart(); // Intercept add to cart
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();